import React from 'react';

const NotFound = () => {
  return (
    <div className='flex items-center justify-center bg-gradient-to-br from-blue-500 to-indigo-800 dark:from-gray-800 dark:to-gray-900 text-white px-4 py-32'>
      <div className='text-center'>
        <h1 className='text-6xl font-bold mb-4'>404</h1>
        <h2 className='text-2xl text-gray-300'>Страница не найдена</h2>
      </div>
    </div>
  );
};

export default NotFound;

